import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { ThemeAssetsPathPipe } from '@core/shared/util';
import { MaintenanceLockViewModel } from '@mp/system/maintenance/domain';

@Component({
  selector: 'mps-maintenance-lock',
  templateUrl: './maintenance-lock.component.html',
  styleUrl: './maintenance-lock.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, MatButton, MatIcon, ThemeAssetsPathPipe],
})
export class MaintenanceLockComponent {
  /**
   * The content of the lock.
   */
  readonly viewModel: InputSignal<MaintenanceLockViewModel> = input.required<MaintenanceLockViewModel>();

  /**
   * Emits when the user wants to switch into another organization.
   */
  readonly switchOrganization: OutputEmitterRef<void> = output<void>();

  /**
   * Emits when the user wants to log out.
   */
  readonly logoutRequested: OutputEmitterRef<void> = output<void>();
}
